import React from 'react';
import { IIcons } from './types';

export const PrivacyFlag = ({color = '#566878'}: IIcons) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0227 8.75839C10.0227 7.6756 10.9674 6.8039 12.1184 6.86009C13.196 6.91625 14.0223 7.78828 14.0223 8.81458V10.1224C14.0223 10.1928 13.9634 10.2632 13.8746 10.2632L10.1556 10.2628C10.0817 10.2628 10.0078 10.2067 10.0078 10.122V8.7584L10.0227 8.75839Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM15.6156 10.2484H15.0399C14.966 10.2484 14.8921 10.1922 14.8921 10.1076V8.81404C14.8921 7.32344 13.6817 6.05791 12.1178 6.00182C10.4796 5.94566 9.12192 7.19699 9.12192 8.75795V10.122C9.12192 10.1924 9.06299 10.2628 8.97416 10.2628H8.39846C8.17724 10.2628 8 10.4317 8 10.6424V15.6203C8 15.8311 8.17724 16 8.39846 16H15.6002C15.8215 16 15.9987 15.8311 15.9987 15.6203L15.9991 10.6282C16.0141 10.417 15.8368 10.2484 15.6156 10.2484Z"
            fill={color}
        />
    </svg>
);
